"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingProgressSteper = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _Radio = require("../../../../../../../ui/Radio");
var _Tooltip = _interopRequireWildcard(require("../../../../../../../ui/Tooltip"));
var _selectors = require("../../../../store/selectors");
var _selectors2 = require("../../../BookingServices/store/selectors");
var _selectors3 = require("../../store/selectors");
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BookingProgressSteper = exports.BookingProgressSteper = function BookingProgressSteper() {
  var fetchBookingServicesUI = (0, _reactRedux.useSelector)(_selectors2.getFetchBookingServicesUI);
  var recalculateOfferPriceUI = (0, _reactRedux.useSelector)(_selectors2.getRecalculateOfferPriceUI);
  var bookingOfferByOperatorUI = (0, _reactRedux.useSelector)(_selectors3.getBookingOfferByOperatorUI);
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getBookingOperator),
    hasOwnBookingServices = _useSelector.hasOwnBookingServices;
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_PROGRESS'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Radio.Radio.Group, {
    className: _styles.default.list
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default.RenderWhen, {
    content: t('STEP_INFO_HINT'),
    isTrue: !hasOwnBookingServices,
    placement: _Tooltip.PLACEMENTS.TOP_LEFT,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
    label: t('FIRST_STEP_TITLE'),
    className: _styles.default.radio,
    checked: fetchBookingServicesUI.completed && !fetchBookingServicesUI.error,
    loading: fetchBookingServicesUI.loading,
    disabled: !hasOwnBookingServices
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default.RenderWhen, {
    content: t('STEP_INFO_HINT'),
    isTrue: !hasOwnBookingServices,
    placement: _Tooltip.PLACEMENTS.TOP_LEFT,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
    label: t('SECOND_STEP_TITLE'),
    className: _styles.default.radio,
    checked: recalculateOfferPriceUI.completed && !recalculateOfferPriceUI.error,
    loading: recalculateOfferPriceUI.loading,
    disabled: !hasOwnBookingServices
  })), /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
    label: t('THIRD_STEP_TITLE'),
    className: _styles.default.radio,
    checked: bookingOfferByOperatorUI.completed && !bookingOfferByOperatorUI.error,
    loading: bookingOfferByOperatorUI.loading
  }));
};